module.exports = __webpack_public_path__ + "img/module-messages.71fa71a2.svg";